var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvauVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 14.3H4.9C3.57452 14.3 2.5 15.3746 2.5 16.7V49.21C2.5 50.5355 3.57452 51.6101 4.9 51.6101H50.4C51.7255 51.6101 52.8 50.5355 52.8 49.21V16.7C52.8 15.3746 51.7255 14.3 50.4 14.3Z",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 51.6001L34.2 59.7001",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2002 59.7001L22.8002 51.6001",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1001 59.7H38.2001",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8999 48.3999H28.4999",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5998 17.5H5.7998V45.07H49.5998V17.5Z",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2998 10.3001C51.9385 10.2868 52.5735 10.4011 53.1674 10.6364C53.7614 10.8716 54.3024 11.2231 54.7587 11.6702C55.2151 12.1172 55.5777 12.6509 55.8251 13.2398C56.0726 13.8288 56.1999 14.4613 56.1998 15.1001",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2002 6.99991C53.358 6.97295 55.4395 7.79769 56.9932 9.29528C58.547 10.7929 59.4477 12.8426 59.5002 14.9999",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2002 3.80002C54.2066 3.77318 57.1019 4.93507 59.2557 7.03272C61.4096 9.13038 62.6476 11.994 62.7002 15",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2999 40.6C32.2152 40.6 36.1999 36.6154 36.1999 31.7001C36.1999 26.7847 32.2152 22.8 27.2999 22.8C22.3846 22.8 18.3999 26.7847 18.3999 31.7001C18.3999 36.6154 22.3846 40.6 27.2999 40.6Z",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5998 28.5H24.7998V35H25.5998L31.2998 31.7L25.5998 28.5Z",
    stroke: "#0587BE",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvauVideo);
export default __webpack_public_path__ + "static/media/avau_video.282aeee20bbe236fe64cd0a5f7a5ee82.svg";
export { ForwardRef as ReactComponent };